import { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { RoutePaths } from "src/pages/routePaths";

interface UseBirthdayListNavigationProps {
  tab: `today` | `tomorrow` | `upcoming`;
}

const useBirthdayListNavigation = (params: UseBirthdayListNavigationProps) => {
  const navigate = useNavigate();
  const { tab } = params;

  const handleNavigateNotification = () => {
    return startTransition(() => navigate(RoutePaths.Birthday + `?tab=${tab}`));
  };

  return {
    handleNavigateNotification,
  };
};

export default useBirthdayListNavigation;